module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_chapel-fefe7b6ea5703f9a59e5014fa9aa220b.webp";